<template lang="pug">
div(:class='inline ? ["columns", "large-24"] : []' v-if="obj.keep_hidden && this.$store.state.current_org.id")
    .future-message
        | {{ t('app.registration.valid_today.obj_is_hidden', {name: t(`app.registration.valid_today.${i18n_klass}`)}) }}
</template>
<script>
export default {
  props: ['obj', 'klass', 'inline'],
  computed: {
    i18n_klass(){
      return this.klass === 'section_option' ? 'sectionoption' : this.klass
    },
  }
}
</script>